<template>
    <div class="page--add_column">
        <div class="item" v-if="action == 'View' || action == 'List'">{{displayColumn()}}</div>
        <div v-else>
            <div class="Date" v-if="type=='Date'">
                <AddColumn v-model="date" @input="changeData" :data="date" :action="'Edit'" :field="{param:{column:[{key:'date',type:'date',is_show:1}]}}"/>
            </div>
            <div class="Time" v-else-if="type=='Time'">
                <AddColumn v-model="time" @input="changeData" :data="time" :action="'Edit'" :field="{param:{column:[{key:'startTime',type:'time',is_show:1},{key:'endTime',type:'time',is_show:1}]}}"/>
                <!-- <vue-timepicker v-model="start" @change="changeData" format="HH:mm"></vue-timepicker> - <vue-timepicker v-model="end" @change="changeData" format="HH:mm"></vue-timepicker> -->
            </div>
            <div class="Weekday" v-else-if="type=='Weekday'">
                <label><input v-model="weekday" @change="changeData" type="checkbox" value="1">{{ $t("weekday.1") }}</label>
                <label><input v-model="weekday" @change="changeData" type="checkbox" value="2">{{ $t("weekday.2") }}</label>
                <label><input v-model="weekday" @change="changeData" type="checkbox" value="3">{{ $t("weekday.3") }}</label>
                <label><input v-model="weekday" @change="changeData" type="checkbox" value="4">{{ $t("weekday.4") }}</label>
                <label><input v-model="weekday" @change="changeData" type="checkbox" value="5">{{ $t("weekday.5") }}</label>
                <label><input v-model="weekday" @change="changeData" type="checkbox" value="6">{{ $t("weekday.6") }}</label>
                <label><input v-model="weekday" @change="changeData" type="checkbox" value="7">{{ $t("weekday.7") }}</label>
            </div>
        </div>

<!--        <div class="input-field">-->
<!--            <input type="description"/>-->
<!--        </div>-->

    </div>
</template>

<script>
import AddColumn from "@/views/custom/edit/AddColumn";
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

export default {
    props: ['data', 'field', 'k', 'action'],
    components: {
        AddColumn,
        VueTimepicker
    },
    created() {
        this.type=this.data.campaignRuleTypeCode;
        if(this.type=="DateExclude") this.type="Date";
        else if(this.type=="TimeInclude") this.type="Time";
        else if(this.type=="DayInclude") this.type="Weekday";
        try {
            let obj = JSON.parse(this.data[this.field.key]);
            if(this.type=="Date") obj.map(x=>{if(x.length>1)this.date.push({"date":x});});
            else if(this.type=="Time") obj.map(r=>{if(r.startTime && r.endTime) this.time.push({"startTime":r.startTime,"endTime":r.endTime})});
            else if(this.type=="Weekday") obj.map(x=>{if(x.length==1)this.weekday.push(x);});
        } catch (error) {
            
        }
        console.log(this.type);
    },
    async beforeMount() {
        
    },
    methods: {
        changeData(){
            let str;
            if(this.type=="Date"){
                str=JSON.stringify(this.date.map((x) => x.date).filter(r=>r.length>0));
            }
            else if(this.type=="Time") {
                str=JSON.stringify(this.time.filter(r=>r.startTime.length>0 && r.endTime.length>0).map(r=>{return {"startTime":r.startTime,"endTime":r.endTime}}));
            }
            else {
                str=JSON.stringify(this.weekday);
            }
            this.$emit("input", str);
        },
        displayColumn(){
            let str = "";
            try {
                let obj = JSON.parse(this.data[this.field.key]);
                let arr = [];
                console.log("displayColumn",this.type)
                if(this.type=="Date") {
                    arr = obj;
                }
                else if(this.type=="Time") {
                    obj.map(r=>{
                        arr.push(r['startTime']+' - '+r['endTime']);
                    })
                }
                else if(this.type=="Weekday") {
                    obj.map(r=>{
                        arr.push(this.$t("weekday."+r));
                    })
                }
                str = arr.join(', ');
            } catch (error) {
                
            }
                
            return str;
        },
        getAutoFill(type, value, lang){

            if (type=='Weekday'){

                value = this.sortStringNumbers(String(value));

                if (!this.autofillweekday.find(item => item.value == value)) return this.convertDayNumberToDayString(value, lang);

                console.log(this.autofillweekday.find(item => item.value == value));

                if (lang == 'cht'){
                    return this.autofillweekday.find(item => item.value == value).cht;
                }else if (lang == 'chs'){
                    return this.autofillweekday.find(item => item.value == value).chs;
                }else {
                    return this.autofillweekday.find(item => item.value == value).en;
                }

            }

            return '';
        },

        sortStringNumbers(str) {
            let numArray = str.split(',').map(Number);
            // Sort the array in ascending order
            numArray.sort((a, b) => a - b);
            // Join the array back into a string
            return numArray.join(',');
        },

        convertDayNumberToDayString(str, lang){
            let numArray = str.split(',');
                // .map(Number);
            return numArray.map(
                value => {
                    const day = this.autofillweekday.find(day => day.value === value);
                    return day? (lang=='cht'? day.cht: lang=='chs'? day.chs: day.en)  : '';
                }
            ).join(', ');
        }

    },
    computed: {

    },

    data() {
        return {
            weekday:[],
            start:"",
            end:"",
            date:[],
            time:[],
            autofillweekday:[
                {"value": "1,2,3,4,5", "en":"Mon-Fri", "cht": "星期一至五", "chs": "星期一至五"},
                {"value": "1,2,3,4,5,6", "en":"Mon-Sat", "cht": "星期一至六", "chs": "星期一至六" },
                {"value": "1,2,3,4,5,6,7", "en":"Mon-Sun", "cht": "星期一至日", "chs": "星期一至日" },
                {
                    "value": "1",
                    "en": "Mon",
                    "cht": "星期一",
                    "chs": "星期一"
                },
                {
                    "value": "2",
                    "en": "Tue",
                    "cht": "星期二",
                    "chs": "星期二"
                },
                {
                    "value": "3",
                    "en": "Wed",
                    "cht": "星期三",
                    "chs": "星期三"
                },
                {
                    "value": "4",
                    "en": "Thu",
                    "cht": "星期四",
                    "chs": "星期四"
                },
                {
                    "value": "5",
                    "en": "Fri",
                    "cht": "星期五",
                    "chs": "星期五"
                },
                {
                    "value": "6",
                    "en": "Sat",
                    "cht": "星期六",
                    "chs": "星期六"
                },
                {
                    "value": "7",
                    "en": "Sun",
                    "cht": "星期日",
                    "chs": "星期日"
                }
            ]
        }
    }
}
</script>

<style lang="scss">
    .page--add_column {
        .Weekday{
            label{
                margin-right: 20px;
            }
        }
    }
</style>